<template>
  <div class="companyprofile">
    <div class="bg">
      <img
        src="@imgs/gsjjbg.png"
        width="341px"
        height="93px"
        alt=""
        class="cpzx"
      />
    </div>
    <div class="companybrief">
      <div class="title">
        <div class="raio"></div>
        <span>公司简介</span>
        <div class="raio"></div>
        </div>
      <div class="content">
        <p>云南润缘医药有限公司成立于2016年，注册资本 100万元，润缘医药是一家专业致力于药品零售的当地知名企业，公司现有零售药店29家，干部职工90余人，门店主要分布在安宁市主城区及周边乡镇。</p>
				<p>成立至今，公司秉承“务实创新、努力拼搏、永不言败”的企业精神，以不断“为客户创造价值，为员工创造前景，为社会创造效益，为股东创造回报”作为公司的使命。</p>
				<p>企业精神：务实创新	  努力拼搏	   永不言败	</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      proList: [
        { id: 0, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 1, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 2, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 3, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 4, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 5, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 6, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 7, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 8, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 9, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 10, img: require("@imgs/pricer.png"), title: "西洋参" },
        { id: 11, img: require("@imgs/pricer.png"), title: "西洋参" },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.companyprofile {

  .companybrief {
    margin-top: 30px;
    .title {
      font-size: 22px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #fe2a1e;
      display: flex;
      justify-content: center;
      align-items: center;
      .raio{
        width: 6px;
        height: 6px;
        background: #fe2a1e;
        border-radius: 50%;
        display: inline-block;
      }
      span{
        margin: 0 7px;
      }
    }
    .content {
      width: 1187px;
      margin: 0 auto;
      margin-bottom: 30px;
      text-align: left;
      font-size: 18px;
      font-family: DengXian;
      color: #666666;
    }
  }
}
</style>